export default class AuthenticationResult {
  changePassword = false;
  publicKey!: string;
}